export const GET = 'get'
export const UPDATE = 'update'
export const CREATE = 'create'
export const DELETE = 'delete'

export const METADATA_SUFFIX = 'Metadata'
